import Layout from "./layout/Layout";
import Base from "./layout/Base";
import Application from "./component/Application";
import Contract from "./component/Contract";
import { useState } from "react";

function Support() {
  const [activeTab, setActiveTab] = useState(0); // 0: 대리점 신청서, 1: 협업신청서

  // 탭에 따라 렌더링할 컴포넌트를 결정
  const renderActiveComponent = () => {
    switch (activeTab) {
      case 0:
        return <Application />;
      case 1:
        return <Contract />;
      default:
        return null;
    }
  };

  return (
    <Base title="고객지원">
      <Layout
        title="Features"
        activeTab={activeTab}
        onTabChange={(tabIndex) => setActiveTab(tabIndex)} // 탭 상태 변경 핸들러
      >
        {renderActiveComponent()}
      </Layout>
    </Base>
  );
}

export default Support;
